import React from 'react';

import type { WrapRootElementBrowserArgs } from 'gatsby';

import ErrorBoundary from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/error-boundary';
import AnalyticsProvider from '../analytics/analytics-provider';
import GlobalError from '../components/global-error';

// Keep the server and browser trees identical so React IDs match during hydration.
export const wrapRootElement = ({ element }: WrapRootElementBrowserArgs): React.JSX.Element => (
	<AnalyticsProvider>
		<ErrorBoundary fallback={<GlobalError />}>{element}</ErrorBoundary>
	</AnalyticsProvider>
);
